import { render, staticRenderFns } from "./SizingChart.vue?vue&type=template&id=079b16ff&scoped=true"
import script from "./SizingChart.vue?vue&type=script&lang=js"
export * from "./SizingChart.vue?vue&type=script&lang=js"
import style0 from "./SizingChart.vue?vue&type=style&index=0&id=079b16ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b16ff",
  null
  
)

export default component.exports